var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotesMedicalSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.875 10.2883V3.28833C2.875 2.3231 3.65977 1.53833 4.625 1.53833H11.625C12.5902 1.53833 13.375 2.3231 13.375 3.28833V8.68872C13.375 9.15356 13.1918 9.59927 12.8637 9.92739L11.2641 11.527C10.9359 11.8551 10.4902 12.0383 10.0254 12.0383H4.625C3.65977 12.0383 2.875 11.2536 2.875 10.2883ZM7.6875 4.16333C7.44688 4.16333 7.25 4.36021 7.25 4.60083V5.91333H5.9375C5.69688 5.91333 5.5 6.11021 5.5 6.35083V7.22583C5.5 7.46645 5.69688 7.66333 5.9375 7.66333H7.25V8.97583C7.25 9.21645 7.44688 9.41333 7.6875 9.41333H8.5625C8.80313 9.41333 9 9.21645 9 8.97583V7.66333H10.3125C10.5531 7.66333 10.75 7.46645 10.75 7.22583V6.35083C10.75 6.11021 10.5531 5.91333 10.3125 5.91333H9V4.60083C9 4.36021 8.80313 4.16333 8.5625 4.16333H7.6875ZM8.34375 13.3508C8.70742 13.3508 9 13.6434 9 14.0071C9 14.3708 8.70742 14.6633 8.34375 14.6633H3.96875C1.91523 14.6633 0.25 12.9981 0.25 10.9446V4.81958C0.25 4.45591 0.542578 4.16333 0.90625 4.16333C1.26992 4.16333 1.5625 4.45591 1.5625 4.81958V10.9446C1.5625 12.2735 2.63984 13.3508 3.96875 13.3508H8.34375Z",
    fill: "#B2B2B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.25 0.66333)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesMedicalSolid);
export default __webpack_public_path__ + "static/media/notes-medical-solid.e600413c89b314c50da398b761e03374.svg";
export { ForwardRef as ReactComponent };